import React from 'react';
import MainichiNaviAI from './components/MainichiNaviAI';
import AdsenseBanner from './components/AdsenseBanner';

function App() {
    return (
        <div>
            <MainichiNaviAI />
            <AdsenseBanner />
        </div>
    );
}

export default App;
